import { useState, useEffect } from 'react';
import { fetchLocations } from '../services/strapi';
import LocationCard from './LocationCard';
const Locations = () => {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [activeLocationId, setActiveLocationId] = useState(2); //Munich

  useEffect(() => {
    const getLocations = async () => {
      try {
        setLoading(true);
        const data = await fetchLocations(); 
        console.log("Fetched Location Data:", data); 
        setLocations(data); 
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    getLocations();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;


  
  return (
    <div className="locations-grid">
      {locations.map(location => (
        <LocationCard key={location.id} location={location}  activeLocationId={activeLocationId}
        setActiveLocationId={setActiveLocationId}/>
          ))}
    </div>
  );
};

export default Locations;
